import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Badge from 'shopper/components/Badge';
import Button from 'shopper/components/Button';

import Image from 'components/Image';

import useSessionStorageState from 'hooks/useSessionStorageState';

import { sendEvent } from 'lib/gtag';
import { formatSponsorSessionStorageKey } from 'lib/sessionStorage';

const NavItem = ({
  bgUrl,
  gaEventAction,
  gaEventCategory,
  icon,
  imageProps = null,
  sameTab = true,
  text,
  unreadStatus = false,
  url,
}) => {
  const [isVisited, setVisited] = useSessionStorageState(
    formatSponsorSessionStorageKey(text)
  );

  const onClick = () => {
    if (unreadStatus) {
      setVisited(true);
    }

    if (bgUrl) {
      window.open(url, '_blank');
    }

    sendEvent({
      action: gaEventAction,
      category: gaEventCategory,
    });
  };

  const Item = (
    <Button
      as="a"
      className="relative mr-4"
      href={bgUrl || url}
      iconLeft={icon}
      rel={(!sameTab || bgUrl) && 'noopener noreferrer'}
      size="size4"
      target={sameTab ? '_self' : '_blank'}
      type="neutral-ghost"
      onClick={onClick}
    >
      {imageProps?.src && (
        <Image
          alt={imageProps.alt || 'logo do patrocinador'}
          className="mr-2 rounded-1"
          height={16}
          src={imageProps.src}
          width={16}
          priority
        />
      )}
      {text}
      {unreadStatus && !isVisited && (
        <Badge
          className="absolute right-0 top-1"
          shape="dot"
          type="highlight"
        />
      )}
    </Button>
  );

  if (bgUrl || !sameTab) {
    return Item;
  }

  return (
    <NextLink href={url} prefetch={false} passHref>
      {Item}
    </NextLink>
  );
};

NavItem.propTypes = {
  bgUrl: PropTypes.string,
  gaEventAction: PropTypes.string.isRequired,
  gaEventCategory: PropTypes.string.isRequired,
  icon: PropTypes.shape(),
  imageProps: PropTypes.shape(),
  sameTab: PropTypes.bool,
  text: PropTypes.string.isRequired,
  unreadStatus: PropTypes.bool,
  url: PropTypes.string.isRequired,
};

export default NavItem;
